import IssueHeader from "./components/IssueHeader";

export default IssueHeader;